import { LightboxImage } from './Lightbox'

const ctaCards = [
  {
    audience: "For Distributors",
    body: "You're not just buying a festival\u2011ready, big\u2011screen firefighter doc; you're inheriting a built\u2011in national conversation about an invisible epidemic that firefighters, families, and unions are ready to amplify with you.",
  },
  {
    audience: "For Your Audience",
    body: "When the lights go down, SPOKE delivers everything you go to the movies for: suspense, humor, heart\u2011in\u2011your\u2011throat rescues, a family you care about. And then shows you the one thing every other firefighter film leaves out - What it really costs to come home.\n\nIt\u2019s the kind of true story people walk out of still talking about in the lobby, texting friends to go see, and carrying with them the next time they hear a siren in the distance.",
  },
  {
    audience: "For Unions and Policymakers",
    body: "SPOKE can do what a hundred memos can't: make cancer, sleep, nutrition, and PTSD real enough that crews start asking for earlier tests, cleaner gear, and time to talk before the next call.",
  },
  {
    audience: "For Brands",
    body: "Help amplify the message of SPOKE. Help get your city\u2019s first CO\u2082 decon machine installed or fund sleep and mental\u2011health pilots for the people everyone already trusts more than any institution.",
  },
]

const CTASection = () => {
  return (
    <section id="why" className="relative w-full bg-[#0a0f1a] overflow-hidden">

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28">
        <div className="grid md:grid-cols-2 gap-8 md:gap-10 items-center">
          <div className="relative bg-white/[0.03] border border-white/10 rounded-lg p-8 md:p-10 hover:border-yellow-400/30 transition-colors duration-300">
            <h3 className="text-2xl md:text-3xl font-montserrat font-black uppercase tracking-wide text-yellow-400 mb-2">
              {ctaCards[0].audience}
            </h3>
            <div className="w-12 h-1 bg-red-600 mb-5"></div>
            <p className="text-gray-300 text-base md:text-lg leading-relaxed font-poppins font-light whitespace-pre-line">
              {ctaCards[0].body}
            </p>
          </div>
          <div className="relative overflow-hidden rounded-lg">
            <LightboxImage
              src="/spoke-static/images/SPOKE_firefighter_Nguyen_portrait.jpg"
              alt="SPOKE film firefighter D. Nguyen standing with arms crossed beside American flag and Renton fire engine"
              className="w-full h-full object-cover rounded-lg"
            />
            <div className="absolute inset-0 rounded-lg ring-1 ring-white/10 pointer-events-none"></div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-8 md:gap-10 items-center mt-8 md:mt-10">
          <div className="relative overflow-hidden rounded-lg order-2 md:order-1">
            <LightboxImage
              src="/spoke-static/images/SPOKE_firefighter_Olson_portrait.jpg"
              alt="SPOKE film firefighter C. Olson smiling with arms crossed in front of Renton fire engine"
              className="w-full h-full object-cover rounded-lg"
            />
            <div className="absolute inset-0 rounded-lg ring-1 ring-white/10 pointer-events-none"></div>
          </div>
          <div className="relative bg-white/[0.03] border border-white/10 rounded-lg p-8 md:p-10 hover:border-yellow-400/30 transition-colors duration-300 order-1 md:order-2">
            <h3 className="text-2xl md:text-3xl font-montserrat font-black uppercase tracking-wide text-yellow-400 mb-2">
              {ctaCards[1].audience}
            </h3>
            <div className="w-12 h-1 bg-red-600 mb-5"></div>
            <p className="text-gray-300 text-base md:text-lg leading-relaxed font-poppins font-light whitespace-pre-line">
              {ctaCards[1].body}
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-8 md:gap-10 items-center mt-8 md:mt-10">
          <div className="relative bg-white/[0.03] border border-white/10 rounded-lg p-8 md:p-10 hover:border-yellow-400/30 transition-colors duration-300">
            <h3 className="text-2xl md:text-3xl font-montserrat font-black uppercase tracking-wide text-yellow-400 mb-2">
              {ctaCards[2].audience}
            </h3>
            <div className="w-12 h-1 bg-red-600 mb-5"></div>
            <p className="text-gray-300 text-base md:text-lg leading-relaxed font-poppins font-light whitespace-pre-line">
              {ctaCards[2].body}
            </p>
          </div>
          <div className="relative overflow-hidden rounded-lg">
            <LightboxImage
              src="/spoke-static/images/SPOKE_firefighter_Reyes_cab.jpg"
              alt="SPOKE film firefighter Reyes smiling from the cab of a Renton fire engine"
              className="w-full h-full object-cover rounded-lg"
            />
            <div className="absolute inset-0 rounded-lg ring-1 ring-white/10 pointer-events-none"></div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-8 md:gap-10 items-center mt-8 md:mt-10">
          <div className="relative overflow-hidden rounded-lg order-2 md:order-1">
            <LightboxImage
              src="/spoke-static/images/SPOKE_firefighter_Lawson_portrait.jpg"
              alt="SPOKE film firefighter L. Lawson standing in front of Renton Regional Fire Authority Engine 313"
              className="w-full h-full object-cover rounded-lg"
            />
            <div className="absolute inset-0 rounded-lg ring-1 ring-white/10 pointer-events-none"></div>
          </div>
          <div className="relative bg-white/[0.03] border border-white/10 rounded-lg p-8 md:p-10 hover:border-yellow-400/30 transition-colors duration-300 order-1 md:order-2">
            <h3 className="text-2xl md:text-3xl font-montserrat font-black uppercase tracking-wide text-yellow-400 mb-2">
              {ctaCards[3].audience}
            </h3>
            <div className="w-12 h-1 bg-red-600 mb-5"></div>
            <p className="text-gray-300 text-base md:text-lg leading-relaxed font-poppins font-light whitespace-pre-line">
              {ctaCards[3].body}
            </p>
          </div>
        </div>

      </div>
    </section>
  )
}

export default CTASection
